import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TheNexusAdvantage from "./sections/TheNexusAdvantage";
import OurGlobalImpact from "./sections/OurGlobalImpact";
import SpecializedIndustryFocus from "./sections/SpecializedIndustryFocus";
import CareerLaunchpad from "./sections/CareerLaunchpad";
import VoicesOfSuccess from "./sections/VoicesOfSuccess";
import StrategicPartners from "./sections/StrategicPartners";
import CorporateFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <TheNexusAdvantage />
      <OurGlobalImpact />
      <SpecializedIndustryFocus />
      <CareerLaunchpad />
      <VoicesOfSuccess />
      <StrategicPartners />
      <CorporateFooter />
    </div>;
}